import React, { useState } from "react";
import PulseSelect from "./Select/PulseSelect";
import useAttributeEditorStyles from "./themes";

import _ from "lodash";
import { SearchResult } from "qpr-base/apihooks/useSearch";
import { useTranslation } from "react-i18next";
import { QueryKey, UseQueryOptions } from "react-query";
import ElementSelect from "./ElementSelect";
import { TMetadataComponentData, TOption } from "./types";

import {
  TDashboardEditComponent,
  TDashboardEditComponentProps,
} from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import PickAttribute from "./PickAttribute";

const AttributeEditor: TDashboardEditComponent = (
  props: TDashboardEditComponentProps
) => {
  const { t } = useTranslation();
  const classes = useAttributeEditorStyles();
  const [searchText, setSearchText] = useState<string>("");
  const { el } = props;
  const ctx = useAppContext();
  const OPTIONS = [{ label: t("KPI"), value: "kpi" }];
  const compData = React.useMemo<TMetadataComponentData | undefined>(() => {
    if (el.component) {
      return el.component.data as TMetadataComponentData;
    }
    return undefined;
  }, [el]);

  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    _.debounce(() => setSearchText(value), 3000);
  };
  const searchOptions: Omit<
    UseQueryOptions<
      { data: SearchResult[] },
      unknown,
      { data: SearchResult[] },
      QueryKey
    >,
    "queryKey" | "queryFn"
  > = {
    enabled: false,
  };
  const [selectedKPI, setSelectedKPI] = React.useState<TOption | undefined>(
    () => compData?.selectedElement
  );
  const [selectedAttribute, setSelectedAttribute] = useState(
    () => compData?.selectedAttribute
  );

  React.useEffect(() => {
    const newComp: Partial<Element> = {
      ...el,
      component: {
        ...(el.component || {}),
        tag: "COMPONENT",
        width: el.component?.width || 500,
        height: el.component?.height || 300,
        component: "metadata",
        data: {
          selectedElement: selectedKPI,
          selectedAttribute: selectedAttribute,
        },
      },
    };

    if (el.paragraphs && el.paragraphs.length > 0) {
      if (selectedAttribute) {
        newComp.paragraphs = [
          {
            portions: [
              {
                ...el.paragraphs![0].portions![0],
                text: selectedAttribute.value,
              },
            ],
            textAlign: ctx.rtl ? "right" : "left",
            rtl: ctx.rtl,
          },
          {
            portions: [],
            textAlign: "",
            rtl: ctx.rtl,
          },
        ];
      }
    } else if (selectedAttribute) {
      newComp.paragraphs = [
        {
          portions: [
            {
              text: selectedAttribute.value,
              fillColor: {
                r: 0,
                g: 0,
                b: 0,
              },
              fontSize: 24,
              fontName: "Dubai Medium",
              textAlign: "right",
            },
          ],
          textAlign: ctx.rtl ? "right" : "left",
          rtl: ctx.rtl,
        },
        {
          portions: [],
          textAlign: "",
          rtl: false,
        },
      ];
    }

    props.onChange(newComp);
  }, [selectedKPI, selectedAttribute]);

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.whiteContainer}>
          <PulseSelect
            name="name"
            placeholder={`${t("myStories.Select")}...`}
            isSearchable={false}
            label={t("myStories.Select Element Type")}
            onChange={handleChange}
            options={OPTIONS}
            value={OPTIONS[0]}
          />
          <ElementSelect
            name="selectedKPI"
            placeholder={`${t("myStories.Select")}...`}
            label={`${t("myStories.Select KPI")}`}
            onChange={(e: any) => {
              console.log(e);
              setSelectedKPI(e);
            }}
            elementType="kpi"
            isSearchable
            value={selectedKPI}
          />
          <PickAttribute
            id={selectedKPI?.value || ""}
            value={selectedAttribute}
            onChange={(value) => setSelectedAttribute(value)}
          />
        </div>
      </div>
    </div>
  );
};
export default AttributeEditor;
